var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    (_vm.$session.type === 'account' ||
    _vm.$session.permissions.any('SHOW_ALL_MENUS', 'SHOP_REASSIGN')) && _vm.show
  )?_c('el-button',{staticClass:"batch-operate-btn",attrs:{"type":"text","disabled":!_vm.show && !_vm.$session.permissions.any('SHOP_REASSIGN', 'SHOW_ALL_MENUS'),"data-matomo":_vm.$store.state.matomo[30].id},on:{"click":_vm.editbindAdmin}},[_vm._v(" "+_vm._s(_vm.$t("main.batch_authorization"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }